export default "__VITE_ASSET__bb35e57c__"